export default __webpack_public_path__ + "static/media/locationIconGrey.630e8d31.svg";